import { DateTime } from "luxon";
import type {
  IdentityMonitoringEnrollment,
  IdentityTheftProtectionRow
} from "./types";

// Backend status → display status mapping
const STATUS_DISPLAY_MAP: Partial<Record<string, string>> = {
  enrolled: "Enrolled",
  canceled: "Declined",
  pending_opt_in: "Invited",
  unenrolled: "Unenrolled"
};

// Action label mapping
const ACTION_DISPLAY_MAP: Partial<Record<string, string>> = {
  enrolled: "Enrolled",
  enroll: "Enrolled",
  canceled: "Declined",
  unenrolled: "Declined",
  pending_opt_in: "Invitation sent",
  invitation_sent: "Invitation sent",
  invitation_declined: "Declined"
};

// Tab → backend enrollment_status param mapping
export enum StatusTab {
  All = "All",
  Enrolled = "Enrolled",
  Invited = "Invited",
  Declined = "Declined"
}

export const TAB_TO_API_STATUS: Record<string, string | undefined> = {
  [StatusTab.Enrolled]: "enrolled",
  [StatusTab.Invited]: "pending_opt_in",
  [StatusTab.Declined]: "canceled",
  [StatusTab.All]: undefined
};

export const TABS = [
  StatusTab.Enrolled,
  StatusTab.Invited,
  StatusTab.Declined,
  StatusTab.All
];

export const PAGE_SIZE = 10;

export const INITIAL_FILTERS = {
  selectedProperties: [] as number[],
  selectedStates: [] as string[],
  lastActivityFrom: "",
  lastActivityTo: ""
};

export const transformEnrollment = (
  enrollment: IdentityMonitoringEnrollment
): IdentityTheftProtectionRow => {
  const lastActivity = enrollment.last_activity;
  const activityAt = DateTime.fromISO(
    lastActivity?.at ?? enrollment.updated_at
  );
  const action = lastActivity?.action ?? enrollment.enrollment_status;
  const enrollmentStatus = enrollment.enrollment_status;
  return {
    id: String(enrollment.id),
    name: enrollment.customer.name,
    property: enrollment.property.name,
    address: enrollment.property.address,
    email: enrollment.customer.email,
    status: STATUS_DISPLAY_MAP[enrollmentStatus] ?? enrollmentStatus,
    lastAction: ACTION_DISPLAY_MAP[action] ?? action,
    lastActivity: activityAt.toFormat("MMM dd, yyyy"),
    lastActivityTime: activityAt.toFormat("h:mm a")
  };
};
